import * as Sentry from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';

declare global {
  interface Window {
    _env_: {
      SENTRY_ENVIRONMENT: string;
      SENTRY_DSN: string;
    }
  }
}

export const sentryInit = function sentryInit() {
  // eslint-disable-next-line no-underscore-dangle
  const sentryDsn = window._env_.SENTRY_DSN;
  // eslint-disable-next-line no-underscore-dangle
  const env = window._env_.SENTRY_ENVIRONMENT;

  // if (sentryDsn && env) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    environment: env || 'development',
  });
};
